<template>
  <div style="margin:  0 auto; width: 80%">
    <el-row style="height: 40px">
      <el-col :span="24">
        <el-button type="primary" size="small" @click="showImport=true" style="margin-right: 15px">导入订单</el-button>
        用户名：<el-input v-model="nick" size="mini" style="width: 120px"></el-input>
        订单号：<el-input v-model="tid" size="mini" style="width: 160px"></el-input>
        <el-button type="primary" size="small" @click="getOuterData" style="margin-right: 15px">搜索</el-button>
        明文：<el-input v-model="enCode" size="mini" style="width: 160px"></el-input>
        密文：<el-input v-model="deCode" size="mini" style="width: 160px"></el-input>
        <el-button type="primary" size="small" @click="encrypt" style="margin-right: 15px">加密</el-button>
        <el-button type="primary" size="small" @click="decrypt" style="margin-right: 15px">解密</el-button>
      </el-col>
    </el-row>

    <el-row style="height: 40px">
      <el-col :span="24">

      </el-col>
    </el-row>

    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination style="color: #000"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pageObject.pageCurrent"
                     :page-sizes="[10, 50, 100, 500, 1000, 2000, 5000]"
                     :page-size="pageObject.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="pageObject.rowCount">
      </el-pagination>
    </div>


    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" :data="outerData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="nick" label="用户名" width="80px"></el-table-column>
          <el-table-column  prop="tid" label="订单号" width="80px"></el-table-column>
          <el-table-column  prop="status" label="订单状态" width="80px"></el-table-column>
          <el-table-column  prop="created" label="拍下时间" width="80px"></el-table-column>
          <el-table-column  prop="payTime" label="付款时间" width="80px"></el-table-column>
          <el-table-column  prop="oprTime" label="时间" width="80px"></el-table-column>
          <el-table-column  prop="enName" label="enName" width="120px"></el-table-column>
          <el-table-column  prop="enMobile" label="enMobile" width="120px"></el-table-column>
          <el-table-column  prop="enAddress" label="enAddress" ></el-table-column>

        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      title="导入数据"
      :visible.sync="showImport"
      width="80%"
      center>
      <span style="margin-left:20px; margin-bottom: 30px">复制Excel表格里的订单（直接全选复制），在这里粘贴</span>
      <el-input :rows="20" type="textarea" v-model="logisTxt" > </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" @click="uploadData">确 定</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import {hideLoading, showLoading} from "../api/loading";

  export default {
    name: "AdmOuter",
    data(){
      return{
        deny:0,
        showImport:false,
        showCompany:false,
        status:'WAIT_SELLER_SEND_GOODS',
        logisTxt:'',
        outerData:[],
        nick:'',
        tid:'',
        enCode:'',
        deCode:'',
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 50,
        },

      }
    },
    methods:{
      indexMethod(index)
      {
        return index + 1;
      },
      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getOuterData();
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getOuterData();
      },
      encrypt: function(){
        let param ={
          data:this.enCode
        }
        $api.post("/en", param, response => {
          let dataResult = response.data;
          console.log(dataResult)
          this.deCode = dataResult.data;
        })
      },

      decrypt: function(){
        let param ={
          data:this.deCode
        }
        $api.post("/de", param, response => {
          let dataResult = response.data;
          console.log(dataResult)
          this.enCode = dataResult.data;
        })
      },
      getOuterData:function () {
        let param={
          nick:this.nick,
          tid: this.tid,
          pageCurrent: this.pageObject.pageCurrent,
          rowCount: this.pageObject.rowCount,
          pageSize: this.pageObject.pageSize,
        }
        $api.post("/outer/getadm", param, response =>{
          let dataResult = response.data;
          console.log(dataResult)
          if (dataResult.state == 1 && dataResult.message == "ok"){
            this.outerData = dataResult.data.outer;


            let pageObject = dataResult.data.pageObject;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
          }
          else{
            this.$message.error(dataResult);

            this.deny = 1;
          }
        })
        hideLoading();
      },
      uploadData:function () {
        this.showImport = false;
        if(this.deny == 1){
          this.$message.error("您没有该权限, 请联系主号分配权限。");
          return;
        }
        let param={
          nick:storage.get("nick"),
          txt: this.logisTxt
        }
        $api.post("/outer/import", param, response =>{
          console.log(response)
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok"){
            this.logisTxt = '';
            this.getOuterData();
            console.log("end.")

          }
          else{
            this.$message.error(dataResult.message);
          }
        })

      },



    },
    mounted(){
      this.getOuterData();
    }
  }
</script>

<style >


</style>



// WEBPACK FOOTER //
// src/admin/AdmOuter.vue